const TumourCards = () => import(/* webpackChunkName: "Tumour" */ "@/views/tumour/cards");
const RhinoCards = () => import(/* webpackChunkName: "Rhino" */ "@/views/rhino/cards");
const CiCards = () => import(/* webpackChunkName: "CI" */ "@/views/ci/cards");
const TagCards = () => import(/* webpackChunkName: "TAG" */ "@/views/tag/cards");
const List = () => import(/* webpackChunkName: "TAGLIST" */ "@/views/common/list");
const FullList = () => import(/* webpackChunkName: "FullList" */ "@/components/common/full-list/main");
const Download = () => import(/* webpackChunkName: "TAG" */ "@/views/download");
const AccessDenied = () => import(/* webpackChunkName: "TAG" */ "@/views/access-denied");

import { i18n } from "../plugins/i18n";
var localisations = i18n[process.env.VUE_APP_LANGUAGE];

export const routes = [
    {
        name: "tumour",
        path: "/tumour",
        meta: { title: localisations.TUMOUR_EVALUATIONS_TITLE },
        components: {
            default: TumourCards,
            cards: TumourCards,
            list: List
        },
    },
    {
        name: "rhino",
        path: "/rhino",
        meta: { title: localisations.RHINO_EVALUATIONS_TITLE },
        components: {
            default: RhinoCards,
            cards: RhinoCards,
            list: List
        },
    },
    {
        name: "ci",
        path: "/ci",
        meta: { title: localisations.CI_EVALUATIONS_TITLE },
        components: {
            default: CiCards,
            cards: CiCards,
            list: List
        },
    },
    {
        name: "tag",
        path: "/tag",
        meta: { title: localisations.TAG_EVALUATIONS_TITLE },
        components: {
            default: TagCards,
            cards: TagCards,
            list: List
        }
    },
    {
        name: "dghnoCi",
        path: "/dghnoCi",
        meta: { title: localisations.DGHNO_CI_EVALUATIONS_TITLE },
        components: {
            default: List,
            cards: TagCards,
            list: List
        }
    },
    {
        name: "fullList",
        path: "/FullList/:type/:property",
        components: {
            default: FullList,
            cards: FullList
        },
        meta: { title: localisations.TITLE },
    },
    {
        name: "download",
        path: "/download/:filename",
        meta: { title: "Download" },
        components: {
            cards: Download,
            list: Download,
        }
    },
    {
        name: 'accessDenied',
        path: '/access-denied',
        meta: { title: "Access Denied" },
        components: {
            cards: AccessDenied,
        }
      }
];
